import type { MascotPose } from '@/components/ui-kit/Mascot'
import { MascotBubble, MascotSlot } from '@/components/ui-kit/Mascot'
import { Headline } from '@/components/ui-kit/Primitives'
import { ScreenShell, TopBar } from '@/components/ui-kit/Shell'

interface MessageScreenProps {
    title: string
    headline: string
    body: string
    bubble: string
    pose: MascotPose
    right?: string
    footer?: React.ReactNode
}

/**
 * Der gemeinsame Aufbau aller Warte- und Übergangsfolien.
 *
 * Wartefolie, Sperrbildschirme, Klassen-Übergang und Abschluss sind
 * dasselbe Bild mit anderem Text - im Clickdummy stand es fünfmal.
 */
export function MessageScreen({
    title,
    headline,
    body,
    bubble,
    pose,
    right,
    footer,
}: MessageScreenProps) {
    return (
        <ScreenShell>
            <TopBar title={title} right={right} />

            <div className="flex flex-1 flex-col items-center justify-center gap-4 text-center">
                <div className="relative">
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_55%,rgb(255_138_26/0.2),transparent_65%)]" />
                    <MascotSlot pose={pose} size={190} />
                </div>

                <MascotBubble side="above">{bubble}</MascotBubble>

                <Headline className="mt-2 text-2xl">{headline}</Headline>
                <p className="max-w-[320px] text-sm text-wb-dim">{body}</p>
            </div>

            {footer && <div className="mt-3">{footer}</div>}
        </ScreenShell>
    )
}
